import Loadable from "react-loadable";
import {Loading} from "./Loading";
import {Route} from "react-router";
import React from "react";


export const route = (path: string, imports: Promise<any>) => {
    const cmp = Loadable({
        loader: () => imports,
        loading: () => <Loading/>,
    });
    return <Route exact path={path} component={cmp} />
}

export const routeStatic = (path: string, component: any) => {
    return <Route exact path={path} component={component} />
}